import { Component, Input } from '@angular/core';

@Component({
    selector: 'my-bar-chart',
    template: require('./bar-chart.component.pug')
})
export class BarChartComponent {
    @Input() barChartLabels: string[];
    @Input() barChartData: Array<any>;

    public barChartType: string = 'bar';
    public barChartOptions: any = {
        scaleShowVerticalLines: false,
        legend: {
            display: false
        }
    };


    constructor() { }

    // private getRandomColor(): string {
    //     let letters = '0123456789ABCDEF';
    //     let color = '#';
    //     for (let i = 0; i < 6; i++) {
    //         color += letters[Math.floor(Math.random() * 16)];
    //     }
    //     return color;
    // }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounting/shared/ui/bar-chart/bar-chart.component.ts